<template>
  <GmapCustomMarker :offsetY="15" :marker="marker" alignment="bottom">
    <div class="point-panel" @click.stop>
      <div class="d-flex">
        <div class="point-panel__info">
          <h6 class="point-panel__info-name">{{ point.name || point.fullName }}</h6>
          <div class="point-panel__detail">
            <div class="point-panel__full-address">
              {{ point.fullName }}
            </div>
            <div class="mb-2">{{ point.lat }}, {{ point.lng }}</div>
            <button class="point-panel__redirect-gmap" @click="handleClickViewGmap">
              {{ $t('fleetTaskInstant.action.viewOnGmap') }}
            </button>
          </div>
        </div>
        <i role="button" @click.stop="$emit('close')" class="close-icon icon-outline_close"></i>
      </div>

      <McButton
        v-if="hasDelete"
        block
        variant="secondary-red"
        size="sm"
        icon="icon-outline_trash"
        :text="$t('fleetTaskInstant.action.removePointFromMap')"
        @click.stop="$emit('click-delete')"
      />
      <McButton
        v-else-if="hasCreate"
        block
        variant="primary"
        size="sm"
        icon="icon-outline_plus"
        :text="$t('fleetTaskInstant.action.addPointFromMap')"
        @click.stop="$emit('click-create')"
      />
    </div>
  </GmapCustomMarker>
</template>

<script>
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import McButton from '@/components/McButton'

export default {
  components: {
    GmapCustomMarker,
    McButton,
  },
  props: {
    point: {
      type: Object,
      default: () => {},
    },
    hasCreate: {
      type: Boolean,
      default: false,
    },
    hasDelete: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click-delete', 'click-create'],
  computed: {
    marker() {
      return {
        lat: this.point.lat,
        lng: this.point.lng,
      }
    },
  },
  methods: {
    handleClickViewGmap() {
      window.open(`https://www.google.com/maps?q=${this.point.lat},${this.point.lng}, `, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.point-panel {
  background-color: $white;
  padding: 12px;
  width: 250px;
  height: 180px;
  border-radius: 4px;
  box-shadow: 0px 4px 8px 0px #10184029;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &::after {
    content: '';
    position: absolute;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 15px solid white;
  }

  &__info {
    display: flex;
    flex-direction: column;
    overflow: hidden;

    &-name {
      font-size: 12px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  &__detail {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__full-address {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  &__redirect-gmap {
    color: $mep-secondary;
    border: none;
    background-color: transparent;
    padding: 0px;
    margin: 0px;
    width: fit-content;
    cursor: pointer;
    display: flex;
    justify-content: left;
    align-items: center;
  }
}
</style>
